<template>
  <div class="p-6 md:px-12">
    <div class="flex justify-end">
      <button @click="logout" class="block py-2 px-6 m-4 rounded bg-grey-light text-white">Logout</button>
    </div>
    <div v-for="(day, date) in days" :key="date" class="mb-8 pb-8">
      <h2 class="mb-4 text-3xl font-light text-grey-darker">{{ formatDate(date) }}</h2>
      <ul class="list-reset flex flex-wrap -mr-6">
        <entry v-for="entry in day" :key="entry.key" :entry="entry"></entry>
      </ul>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import firebase from "firebase";
import * as groupBy from "lodash/groupBy";
import { DateTime } from "luxon";
import Entry from "@/components/Entry";
import bus from "@/bus";

let firebaseConfig = {
  apiKey: "AIzaSyBfXUBuRX6KK85Opp8Q1onCL2kCkxpSCgQ",
  authDomain: "timetracker-27179.firebaseapp.com",
  databaseURL: "https://timetracker-27179.firebaseio.com",
  projectId: "timetracker-27179",
  storageBucket: "timetracker-27179.appspot.com",
  messagingSenderId: "303257807676"
};
let db = firebase.initializeApp(firebaseConfig).database();
var provider = new firebase.auth.GoogleAuthProvider();

export default {
  name: "timesheet",

  data: () => ({
    user: null
  }),

  beforeCreate() {
    firebase.auth().onAuthStateChanged(user => {
      if (!user) {
        firebase
          .auth()
          .signInWithRedirect(provider)
          .then(function(result) {
            console.log(result);
          })
          .catch(console.error);
      }
    });
  },

  created() {
    bus.$on('deleteEntry', entry => {
      this.$firebaseRefs.entries.child(entry['.key']).remove()
    });
  },

  firebase: {
    entries: db
      .ref("entries")
      .orderByChild("date")
      .startAt("2018-02-01")
  },

  components: {
    Entry
  },

  computed: {
    days() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      let entries = [...this.entries].reverse();

      let dates = groupBy(entries, "date");

      for (let date of Object.keys(dates)) {
        dates[date].reverse();
      }

      return dates;
    }
  },

  methods: {
    logout() {
      firebase.auth().signOut();
    },

    formatDate(isoTime) {
      return DateTime.fromISO(isoTime)
        .setLocale("de")
        .toLocaleString(DateTime.DATE_HUGE);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Timesheet.vue